import snackbar from './snackbar';

export default {
    namespaced: true,
    modules: {
        snackbar
    }
}